import { getHistoryUrlParams } from '@/store/gamestate/gamestate'
import { getRouteNameByStudyTab } from '@/store/router/router'
import { SNK } from '@/helpers/helpers'
import findLast from 'lodash/findLast'
import router from '@/router'

function getInitialState({ namespace }) {
  const res = {
    sol_namespace: namespace,
  }
  return res
}

const getters = {
  sol_usingCussolReports: (_state, getters, _rootState, rootGetters) =>
    rootGetters.user_has_flag('CR_REPORTS') &&
    getters.sol_elite.want_use &&
    getRouteNameByStudyTab(router, rootGetters) === 'StudyReports',

  sol_eliteTierPurchased: (_state, _getters, _rootState, rootGetters) =>
    !!(rootGetters.user_info?.subs || []).find(i => i.plan.tier === 'ELITE'),
  sol_eliteMTTTierPurchased: (_state, _getters, _rootState, rootGetters) =>
    !!(rootGetters.user_info?.subs || []).find(
      i => i.plan.game_format === 'MTT' && i.plan.tier === 'ELITE',
    ),
  sol_eliteWantUseButMustCreate: (_state, getters, _rootState, rootGetters) =>
    getters.sol_elite.want_use && getters.sol_elite.must_create,
  sol_elite: (state, getters, _rootState, rootGetters) => {
    const custom_solution_history = rootGetters.api_get('api_poker_custom_solution_history')
    const custom_reports_history = rootGetters.api_get('api_custom_aggregated_report_table')
    const custom_solution_tree = rootGetters.api_get(
      'api_poker_custom_solution_tree',
      state.sol_namespace,
    )
    const custom_solution = rootGetters.api_get('api_poker_custom_solution', state.sol_namespace)

    const cSol = custom_solution.response?.data
    const cTree = cSol?.custom_tree || custom_solution_tree.response?.data
    const cHistory = custom_solution_history.response?.data
    const cReportsHistory = custom_reports_history.response?.data
    const loading_what = custom_solution.loading
      ? 'custom_solution'
      : custom_solution_tree.loading
        ? 'custom_solution_tree'
        : ''

    const error_what = custom_solution.error
      ? 'custom_solution'
      : custom_solution_tree.error
        ? 'custom_solution_tree'
        : ''

    const tournamentType = cTree?.tournament_data ? 'icm' : 'chipev'

    const can_use = getters.sol_eliteTierPurchased
    const want_use = getters.query_solution_type === 'custom'

    const must_upgrade = want_use && !can_use
    const is_elite_using = want_use && can_use
    const is_elite_without_rake = is_elite_using && !rootGetters.has_access_to_rake_ai
    const is_elite_without_icm =
      tournamentType === 'icm' && is_elite_using && !getters.sol_eliteMTTTierPurchased

    // FE fix - initial load -  so this we must fix so that is_using is correct on initial load
    const must_create =
      !cTree && !cSol && !cHistory?.results?.length && !cReportsHistory?.results?.length // has never created anything
    const has_history = !!cHistory?.results?.length || !!cReportsHistory?.results?.length
    const is_using = want_use && !must_create

    const cussol_id = getters.query_cussol_id
    const custree_id = getters.query_custree_id

    const custom_tree_id = cSol?.custom_tree?.id || cTree?.id || custree_id
    const custom_solution_id = cSol?.id || cussol_id

    const custom_tree_loaded = cTree && custree_id === cTree.id
    const custom_solution_loaded = cSol && cussol_id === cSol.id && custom_tree_loaded

    const must_add_board =
      want_use &&
      !custom_solution_loaded &&
      !custom_solution.loading &&
      cTree?.starting_street === 'FLOP' // missing just board

    const res = {
      can_use,
      want_use,
      is_using,
      must_upgrade,
      is_elite_using,
      is_elite_without_rake,
      is_elite_without_icm,
      must_create,
      has_history,
      starting_street: cTree?.starting_street,
      is_preflop: cTree?.starting_street === 'PREFLOP',
      // is_using_has_used,

      must_add_board,

      loading_what,
      error_what,

      custom_solution_id,
      custom_tree_id,

      // --dev - review later keep for now here
      query_solution_type: getters.query_solution_type,
      cSol,
      cTree,
      tournamentType,
      custom_solution,
      custom_solution_tree,
      custom_solution_history,

      custom_tree_loaded,
      custom_solution_loaded,
      custom_solution_history_loaded: !!cHistory,
    }
    // console.log(res, state.sol_namespace, 'sol_elite')
    return res
  },
}

const actions = {
  sol_resetApiSolutionCache(
    { state, commit, dispatch, getters, rootGetters },
    { cussol_id, board },
  ) {
    // reset cussol cache - so latest sol appears on top in gmf custom solutions table
    // api needs to be called on each board change even though it is some already visited solution
    // --
    // this might reset cache of diff solution using same board but so be it (no way now to know which sol is using board, beforehand)
    // we'd have to have all of them locally stored
    const gwApiCache = rootGetters.get_gwApiCache()
    const cacheIds = Object.keys(gwApiCache).filter(
      i =>
        i.includes('custom_solution_id') &&
        (!cussol_id || i.includes(cussol_id)) &&
        (!board || i.includes(`board=${board}`)),
    )
    // console.log(cacheIds, 'cacheIds')
    cacheIds.forEach(id => {
      dispatch(
        'gwApiCache_delete',
        {
          id,
        },
        { root: true },
      )
    })
  },
  sol_resetCustomSol(
    { state, commit, dispatch, getters, rootGetters },
    { item, channelId, routerParams, updateRouterParamsOnly },
  ) {
    if (channelId) {
      dispatch(
        'bc_postMessage',
        {
          channelId,
          data: {
            code: 'sol_resetCustomSol',
            value: JSON.parse(
              JSON.stringify({
                item,
                routerParams,
                namespace: state.sol_namespace,
              }),
            ),
          },
        },
        { root: true },
      )
    }

    dispatch('sol_resetApiSolutionCache', { cussol_id: item?.solution?.id })
    dispatch(
      'api_cancel_pending_requests',
      {
        callIds: [
          `poker/history/`,
          `poker/next-actions/`,
          `poker/custom-solutions/`, // v1
          `custom-solutions/`, // v4
        ],
      },
      { root: true },
    )

    if (updateRouterParamsOnly) {
      // should be picked up by watcher PokerHistoryEvents
      dispatch(SNK('sol_setSolutionQuery', state.sol_namespace), {
        item,
      })
      return
    }

    dispatch('globals_action', 'disable_history_watcher', { root: true })
    setTimeout(() => {
      if (item) {
        commit('gamestate_set', {
          key: 'history_spots',
          value: [],
        })

        dispatch('sol_setSolutionQuery', {
          item,
          query: { history_spot: '', board: item.solution?.board || '' },
          routerParams,
        })
      }
      dispatch('sol_studyInitialize')
    }, 0)
  },
  sol_setSolutionQuery(
    { state, commit, dispatch, getters },
    {
      item,
      query = {},
      routerParams = {
        push: true,
        replace: false,
        saveLocally: true,
      },
    },
  ) {
    if (!item) {
      dispatch('router_update_query', {
        query: {
          solution_type: 'custom',
          soltab: 'strategy',
        },
        ...routerParams,
      })
      return
    }

    const aa = item.solution?.actions || item.actions
    const urlActions = {
      flop_actions: (aa?.flop_actions || []).join('-') || '',
      preflop_actions: (aa?.preflop_actions || []).join('-') || '',
      river_actions: (aa?.river_actions || []).join('-') || '',
      turn_actions: (aa?.turn_actions || []).join('-') || '',
    }
    const l_query = {
      ...getters.query_gmfSelector,
      ...urlActions,
      cussol_id: item?.solution?.id || item?.id,
      custree_id: item?.solution?.custom_tree?.id || item?.custom_tree?.id,
      solution_type: 'custom',
      soltab: 'strategy',
      board: item?.board || '',
      ...query,
    }
    dispatch('router_update_query', {
      query: l_query,
      ...routerParams,
    })
  },
  sol_setTrainerQuery(
    { state, commit, dispatch, getters },
    {
      routerParams = {
        push: true,
        replace: false,
        saveLocally: true,
      },
    },
  ) {
    const query = {
      custree_id: '',
      cussol_id: '',
      solution_type: 'custom',
    }
    dispatch('router_update_query', {
      query,
      ...routerParams,
    })
  },
  sol_switchSolTypeNEW(
    { state, commit, dispatch, getters, rootGetters },
    { channelId, solType, gmfs_solution_tab },
  ) {
    const query = {
      ...(gmfs_solution_tab ? { gmfs_solution_tab } : {}),
      solution_type: solType,
      ...(solType === 'gwiz'
        ? {
            history_spot: 0,
            board: '',
            preflop_actions: '',
            flop_actions: '',
            turn_actions: '',
            river_actions: '',
          }
        : {}),
    }

    dispatch('router_update_query', {
      query,
      push: true,
      replace: false,
      saveLocally: true,
    })

    const soltab = gmfs_solution_tab === 'ai_reports' ? 'reports' : 'strategy'

    dispatch('poker_sync_study_tabs', { soltab }, { root: true })
    dispatch(
      'switchers_set_item',
      {
        key: 'sw_tabs_study',
        item: { payload: soltab },
      },
      { root: true },
    )

    if (channelId) {
      dispatch(
        'bc_postMessage',
        {
          channelId,
          data: {
            code: 'sol_switchSolType',
            value: {
              namespace: state.sol_namespace,
              solType,
              gmfs_solution_tab,
            },
          },
        },
        { root: true },
      )
    }
  },
  sol_switchSolType(
    { state, commit, dispatch, getters, rootGetters },
    { namespace, channelId, solType, gmfs_solution_tab },
  ) {
    if (channelId) {
      dispatch(
        'bc_postMessage',
        {
          channelId,
          data: {
            code: 'sol_switchSolType',
            value: {
              namespace: state.sol_namespace,
              solType,
              gmfs_solution_tab,
            },
          },
        },
        { root: true },
      )
    }

    const query = {
      ...(gmfs_solution_tab ? { gmfs_solution_tab } : {}),
      solution_type: solType,
      board: '',
    }

    dispatch(
      'api_cancel_pending_requests',
      {
        callIds: [`poker/history/`, `poker/next-actions/`, `poker/custom-solutions/`],
      },
      { root: true },
    )

    dispatch('globals_action', 'disable_history_watcher', { root: true })
    setTimeout(() => {
      if (solType === 'custom') {
        const solHistoryData = rootGetters.api_get_data('api_poker_custom_solution_history')
        const solElite = getters.sol_elite
        const item = solHistoryData?.results?.[0]

        if (!solElite?.cSol && !!solElite?.cTree) {
          // must_add_board
          dispatch('router_update_query', {
            query,
            push: true,
          })
          commit('gamestate_set', {
            key: 'history_spots',
            value: [],
          })
          return
        }

        if (!item && !solElite?.must_add_board) {
          // when no history keep current sol. library tree
          dispatch('router_update_query', {
            query,
            push: true,
          })
        } else {
          dispatch('gamestate_reset_history', {
            query,
            routerParams: {
              push: true,
              replace: false,
              saveLocally: false,
            },
          })
        }
        if (getters.sol_elite.must_create) return
        dispatch('gamestate_reset_history', {
          query,
          routerParams: {
            push: true,
            replace: false,
            saveLocally: false,
          },
        })
        dispatch('sol_studyInitialize')
      } else {
        dispatch('gamestate_reset_history', {
          query,
          routerParams: {
            push: true,
            replace: false,
            saveLocally: false,
          },
        })
        dispatch(
          'api_poker_history',
          {
            namespace,
            enable_hsWatcher: true,
          },
          { root: true },
        )
      }
    }, 0)
  },
  sol_cust_handleBoardChange({ state, commit, dispatch, getters }, { board, solElite }) {
    if (board.length === 6 && !solElite.is_preflop) {
      dispatch('sol_createSolution', {
        callNextActions: true,
      })

      return
    }

    dispatch('sol_createSolutionFromParent', { board })
  },
  async sol_studyInitialize({ state, commit, dispatch, rootGetters }, { actionArgs = {} } = {}) {
    if (rootGetters.user_has_flag('CR_REPORTS')) {
      dispatch('sol_studyInitializeNEW', { actionArgs })
      return
    }
    await dispatch('sol_studyInitializeOLD', { actionArgs })
  },
  async sol_studyInitializeOLD({ state, commit, dispatch, getters }, { actionArgs = {} } = {}) {
    const solElite = getters.sol_elite

    if (solElite.want_use) {
      const cussol_id = getters.query_cussol_id
      if (cussol_id) {
        await dispatch('sol_getSolution', { actionArgs })
        return
      }
      dispatch('sol_setDefaultFromHistory')
    }
  },
  sol_studyInitializeNEW({ state, commit, dispatch, getters }, { actionArgs = {} } = {}) {
    const solElite = getters.sol_elite
    if (solElite.want_use) {
      const cussol_id = getters.query_cussol_id
      // already loaded
      if (cussol_id && solElite.cSol?.id === cussol_id) {
        if (actionArgs.callHistory) {
          dispatch(
            'api_poker_history',
            {
              cussol_id,
              namespace: state.sol_namespace,
              enable_hsWatcher: true,
            },
            { root: true },
          )
        }
        return
      }

      if (cussol_id) {
        dispatch('sol_getSolution', { actionArgs })
        return
      }

      const custree_id = getters.query_custree_id
      if (solElite.must_add_board && solElite.custom_tree_loaded) {
        // add board situation
        dispatch('gamestate_reset_history', {
          query: {
            custree_id,
            cussol_id: '',
            board: '',
          },
        })
        return
      }

      if (custree_id) {
        dispatch('sol_getTree', {
          actionArgs: {
            solfigrNewTreeMode: 'handletree_studyTab',
          },
        })
        return
      }
      dispatch('sol_setDefaultFromHistory')
    }
  },
  sol_reportsInitialize({ state, commit, dispatch, getters }) {
    const solElite = getters.sol_elite
    if (solElite.want_use) {
      const custree_id = getters.query_custree_id
      if (custree_id && solElite.cTree?.id === custree_id) return // already loaded

      if (custree_id) {
        dispatch('globals_action', 'disable_history_watcher', { root: true })

        dispatch('gamestate_reset_history', {
          query: {
            custree_id,
            preflop_actions: getters.router_query.preflop_actions,
          },
        })
        setTimeout(() => {
          dispatch('sol_getTree', {
            actionArgs: {
              solfigrNewTreeMode: 'handletree_reportsTab',
            },
          })
        }, 0)
        return
      }
      dispatch('sol_setDefaultFromHistory')
    }
  },
  sol_getTree({ state, commit, dispatch, getters }, { actionArgs }) {
    dispatch(
      'api_poker_custom_solution_tree',
      {
        id: getters.query_custree_id,
        action: SNK('slfrm_handleNewTree', state.sol_namespace),
        namespace: state.sol_namespace,
        actionArgs,
      },
      { root: true },
    )
  },

  sol_trainerInitialize({ state, commit, dispatch, getters }) {
    const solElite = getters.sol_elite
    const customTreeId = solElite.custom_tree_loaded
      ? solElite.custom_tree_id
      : getters.query_custree_id

    if (solElite.want_use) {
      if (!customTreeId) {
        // debugger
        console.log('no custom tree id - reverting to sol.library')
        const query = {
          custree_id: '',
          cussol_id: '',
          solution_type: 'gwiz',
          fh_start_spot: 'preflop',
        }
        dispatch('router_update_query', {
          query,
        })
        return
      }
      dispatch(
        'api_poker_custom_solution_tree',
        {
          id: customTreeId,
          action: SNK('sol_trainerHandleTree', state.sol_namespace),
          namespace: state.sol_namespace,
        },
        { root: true },
      )
    }
  },
  sol_trainerHandleTree({ state, commit, dispatch, getters }, result) {
    if (result?.response?.status !== 200 || !result.response?.data) {
      dispatch(
        'tra/alpha/router_update_query',
        {
          query: {
            cussol_id: '',
            custree_id: '',
            solution_type: 'gwiz',
            fh_start_spot: 'preflop',
          },
          push: true,
        },
        { root: true },
      )

      const status = result?.status
      dispatch(
        'messages',
        {
          type: 'error',
          status: 'err_message',
          statusMessages: {
            _err_message: {
              i18n: `messages.get_custom_tree_error`,
              i18nParams: { status: status || 'unknown' },
            },
          },
        },
        { root: true },
      )
    }
  },
  sol_customHandleSolution({ state, commit, dispatch, getters }, result) {
    const { actionArgs } = result
    if (result?.response?.status !== 200 || !result.response?.data) {
      dispatch(
        SNK('router_update_query', state.sol_namespace),
        {
          query: {
            cussol_id: '',
            custree_id: '',
            solution_type: 'custom',
            preflop_actions: '',
            flop_actions: '',
            turn_actions: '',
            river_actions: '',
          },
          push: false,
          replace: false,
          saveLocally: false,
        },
        { root: true },
      )

      dispatch('sol_setDefaultFromHistory', { actionArgs })
      return
    }
    const solData = result.response.data
    dispatch('gamestate_applySolution', {
      solData,
      callHistory: actionArgs.callHistory ?? true,
    })
  },
  sol_customHandleCreateSolution({ state, commit, dispatch, getters }, result) {
    const { actionArgs } = result

    if (result?.status === 403) return
    if (result?.status !== 201 || !result.response?.data) {
      const status = result?.status
      dispatch(
        'messages',
        {
          type: 'error',
          status: 'err_message',
          statusMessages: {
            _err_message: {
              i18n: `messages.solution_creation_error`,
              i18nParams: { status: status || 'unknown' },
            },
          },
        },
        { root: true },
      )
      return
    }

    const solData = result.response.data

    dispatch('gamestate_applySolution', {
      solData,
      callNextActions: actionArgs.callNextActions ?? true,
      callHistory: actionArgs.callHistory,
      updateUrlImmediately: actionArgs.updateUrlImmediately,
    })
  },
  sol_customHandleCreateSolutionFromParent({ state, commit, dispatch, getters }, result) {
    if (result?.response?.status !== 201 || !result.response?.data) {
      const status = result?.status
      dispatch(
        'messages',
        {
          type: 'error',
          status: 'err_message',
          statusMessages: {
            _err_message: {
              i18n: `messages.solution_creation_error`,
              i18nParams: { status: status || 'unknown' },
            },
          },
        },
        { root: true },
      )
      return
    }
    const solData = result.response.data
    dispatch('gamestate_applySolution', {
      solData,
      // resetHistory: false,
      callNextActions: true,
    })
  },
  async sol_setDefaultFromHistory({ state, commit, dispatch, getters, rootGetters }, result) {
    const solHistory = rootGetters.api_get('api_poker_custom_solution_history')
    if (!solHistory?.loaded) {
      if (result?.times === 1) {
        // stop here dont loop
        debugger
        return
      }
      dispatch(
        'api_poker_custom_solution_history_initial',
        {
          afterAction: SNK('sol_setDefaultFromHistory', state.sol_namespace),
          afterActionArgs: { times: 1 },
        },
        { root: true },
      )
    }

    const solHistoryData = rootGetters.api_get_data('api_poker_custom_solution_history')
    const item = solHistoryData?.results?.[0]
    if (!item) {
      // no solution yet so default to sol lib hSpots
      dispatch('globals_action', 'disable_history_watcher', { root: true })
      setTimeout(() => {
        dispatch(
          SNK('router_update_query', state.sol_namespace),
          {
            query: {
              cussol_id: '',
              custree_id: '',
              solution_type: 'custom',
              preflop_actions: '',
              flop_actions: '',
              turn_actions: '',
              river_actions: '',
            },
            push: false,
            replace: false,
            saveLocally: false,
          },
          { root: true },
        )
        dispatch(
          'api_poker_history',
          {
            namespace: state.sol_namespace,
            enable_hsWatcher: true,
          },
          { root: true },
        )
      }, 0)
      return
    }

    const channelId = rootGetters.bc_channels_ids.find(id => id.includes('floating_gmf'))
    dispatch('sol_resetCustomSol', {
      item,
      channelId,
      routerParams: {
        push: true,
        replace: false,
        saveLocally: true,
      },
    })
  },
  async sol_getSolution({ state, commit, dispatch, getters }, { actionArgs = {} } = {}) {
    await dispatch(
      'api_poker_custom_solution',
      {
        action: SNK('sol_customHandleSolution', state.sol_namespace),
        actionArgs,
        id: getters.query_cussol_id,
        namespace: state.sol_namespace,
      },
      { root: true },
    )
  },
  sol_createSolution({ state, commit, dispatch, getters }, { resetHistory = true } = {}) {
    // TODO hadnel betrer situation when thes no solution history and you browse sol.lib under custom sol in url
    if (!getters.query_custree_id) {
      debugger
      return
    }
    dispatch('globals_action', 'disable_history_watcher', { root: true })

    setTimeout(() => {
      if (resetHistory) {
        dispatch('gamestate_reset_history', { namespace: state.sol_namespace })
      }
      dispatch(
        'api_poker_custom_solution_create',
        {
          action: SNK('sol_customHandleCreateSolution', state.sol_namespace),
          actionArgs: {
            callNextActions: true,
          },
          namespace: state.sol_namespace,
          message: null,
          data: {
            custom_tree_id: getters.query_custree_id,
            board: getters.query_board.slice(0) || 'QsTs7h',
            actions: '', // flop is empty
          },
        },
        { root: true },
      )
    }, 0)
  },
  sol_createSolutionFromParent({ state, commit, dispatch, getters }) {
    if (!getters.query_cussol_id || !getters.query_board) return
    dispatch('globals_action', 'disable_history_watcher', { root: true })
    setTimeout(() => {
      const board = getters.query_board
      let hSpots = getters.history_spots

      const prevStreet = board.length === 8 ? 'flop' : board.length === 10 ? 'turn' : 'preflop'
      if (!board) {
        debugger
      }

      const lastStreetSpot = findLast(hSpots, i => i.street === prevStreet)
      hSpots = hSpots.filter(i => i.id <= lastStreetSpot.id)

      const hSpotsParams = getHistoryUrlParams({ history_spots: hSpots, includeShowdown: false })
      const l_actions = [
        hSpotsParams.preflop_actions,
        hSpotsParams.flop_actions,
        hSpotsParams.turn_actions,
        hSpotsParams.river_actions,
      ]
        .filter(i => i)
        .join('-')

      const spot = hSpots[hSpots.length - 1]
      const spot_id = spot.id
      const parent_solution_id = spot.custom_solution_id

      dispatch('gamestate_set_history', {
        history_spots: hSpots,
        spot_id,
        push: false,
        replace: true,
        saveLocally: true,
      })

      dispatch(
        'api_poker_custom_solution_create',
        {
          action: SNK('sol_customHandleCreateSolutionFromParent', state.sol_namespace),
          data: {
            parent_solution_id,
            board,
            actions: l_actions,
          },
          namespace: state.sol_namespace,
        },
        { root: true },
      )
    }, 0)
  },
  async sol_autoCreateCustomSolution(
    { state, commit, dispatch, getters },
    { board, custom_tree_id },
  ) {
    const result = await dispatch(
      'api_poker_custom_solution_create',
      {
        action: SNK('sol_customHandleCreateSolution', state.sol_namespace),
        actionArgs: {
          callHistory: true,
          callNextActions: false,
          updateUrlImmediately: true,
        },
        namespace: state.sol_namespace,
        message: null,
        data: {
          custom_tree_id,
          board,
          actions: '', // flop is empty
        },
      },
      { root: true },
    )
    return result
  },
}

const mutations = {}

function getCustomSolModule(namespace = '') {
  return {
    state: getInitialState({ namespace }),
    getters,
    actions,
    mutations,
  }
}

export { getCustomSolModule }
